module.exports = __webpack_public_path__ + "static/cnn_logo_shadowed-7fef5b1c4ed7d9df8be5d4709adf14a3.png";